import styled from 'styled-components';

import THEME from '../../../../../constants/theme';

export const AgentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Container = styled.div`
  border-bottom: 1px solid ${THEME.lightGrey};
  display: flex;
  flex-direction: column;
  padding: 40px 25px 40px 40px;
`;

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const SelectContainer = styled.div`
  display: flex;
  width: 120px;
`;

export const Title = styled.p`
  color: ${THEME.grey};
  font-family: Montserrat;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.25;
  margin: 0 25px 0 0;
`;
